const Schedule = {

    // FIELDS
    "session_id": "Session",
    "course_id": "Course",
    "semester_id": "Semester",
    "subject_id": "Subject",
    "user_id": "Teacher",
    "duration": "Duration",
    "from_date": "From Date",
    "to_date": "To Date",
    "start_time": "Start Time",
    "end_time": "End Time",
    "online_link": "Online Link",
    "remark": "Remark",
    "masterDays": "Select Days",
    "schedule_name": "Schedule Name",
    "schedule_date": "Schedule Date",
    "link": "Class Link",
    "teacher_id": "Teacher",
    "description": "Description",

    // PAGE HEADER
    "schedule": "Schedule",
    "addSchedule": "Add Schedule",
    "updateSchedule": "Update Schedule",
    "scheduleList": "Schedule List",

    // ERROR
    "error_session": "Select Session",
    "error_course": "Select Course",
    "error_semester": "Select Semester",
    "error_subject": "Select Subject",
    "error_teacher": "Select Teacher",
    "error_duration": "Enter Duration",
    "error_from_date": "Select From Date",
    "error_to_date": "Select To Date",
    "error_start_time": "Select Start Time",
    "error_end_time": "Select End Time",
    "error_online_link": "Enter Online Link",
    "error_valid_link": "Please enter a valid URL (http:// or https://)",
    "error_master_days": "At least one day must be selected",

    // TABLE HEADER
    "table_session": "BATCH",
    "table_course": "COURSE",
    "table_semester": "SEMESTER",
    "table_subject": "SUBJECT",
    "table_teacher": "TEACHER",
    "table_link": "CLASS LINK",
    "table_duration": "DURATION",
    "table_from_date": "FROM DATE",
    "table_to_date": "TO DATE",
    "table_schedule_name": "SCHEDULE NAME",
    "table_schedule_date": "SCHEDULE DATE",
    "table_start_time": "START TIME",
    "table_end_time": "END TIME",
}

export default Schedule;
